import * as React from 'react'

import { get } from 'lodash'
import { TableBody, TableCell, TableRow, cn } from 'twyne-new.ui'

import { pinnedCellProps } from '@Components/tableResize/pinned'

const EMPTY_INDEXES = []
const EMPTY_OFFSETS = {}

const Body = ({ data, columns, rowClassName, keyField, rowWrapper, pinnedIndexes = EMPTY_INDEXES, offsets = EMPTY_OFFSETS }) => {
  if (!data || data.length === 0) {
    return null
  }

  const RowWrapper = rowWrapper || TableRow
  return <TableBody>
    {data.map((row, rowIndex) => {
      const rowKey = keyField ? row[keyField] : rowIndex
      return <RowWrapper
        className={cn(rowClassName && rowClassName(row), rowIndex % 2 && 'twy-bg-base')}
        key={rowKey}
        row={{ ...row, index: rowIndex }}
      >
        {columns.map((column, colIndex) => {
          const pinned = pinnedCellProps({ index: colIndex, rowIndex, pinnedIndexes, offsets })

          return <DefaultTableCell
            key={colIndex}
            className={cn(column.className, pinned.className)}
            style={pinned.style}
            rowIndex={rowIndex}
          >
            {column.formatter ? column.formatter(get(row, column.dataField), row, rowIndex) : get(row, column.dataField)}
          </DefaultTableCell>
        })}
      </RowWrapper>
    })}
  </TableBody>
}

const DefaultTableCell = ({ children, className, style, rowIndex }) => <TableCell
  style={style}
  className={cn(
    'truncate max-w-80',
    className,
    rowIndex % 2 ? 'twy-bg-base' : 'twy-bg-base-accent',
  )}>
  {children}
</TableCell>

export default React.memo(Body)
